import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/packages/studio/components/AppLoading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/packages/studio/components/AuthCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/packages/studio/components/ConfigureAmplifyClientSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/packages/studio/components/IntercomScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/packages/studio/components/PreAuthInitializers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/packages/studio/components/SegmentScript.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/studio/components/web-vitals/CustomWebVitalsTracker.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/studio/config/app.config.ts");
;
import(/* webpackMode: "eager" */ "/root/project/packages/studio/node_modules/next/font/google/target.css?{\"path\":\"app/(app)/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PolarisProvider"] */ "/root/project/packages/studio/providers/PolarisProvider.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/studio/styles/globals.css");
